import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const RELOCATION_ORDER_CREATE_RESOURCE = "relocation-order" as const;
export const RELOCATION_ORDER_CREATE_API_PATH = `/v1/${RELOCATION_ORDER_CREATE_RESOURCE}` as const;

export type RelocationOrderCreateBody =
  paths[typeof RELOCATION_ORDER_CREATE_API_PATH]["post"]["requestBody"]["content"]["application/json"];
export type RelocationOrderCreateResponse =
  paths[typeof RELOCATION_ORDER_CREATE_API_PATH]["post"]["responses"][200]["content"]["application/json"];

export const useRelocationOrderCreateMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<RelocationOrderCreateResponse, Error, RelocationOrderCreateBody>({
    mutationFn: async (relocationOrderCreateBody: RelocationOrderCreateBody) => {
      const response = await alphartisApiAxios.post<RelocationOrderCreateResponse>(
        RELOCATION_ORDER_CREATE_API_PATH,
        relocationOrderCreateBody,
      );
      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [RELOCATION_ORDER_CREATE_RESOURCE],
      });
    },
  });
};
